import {Delete} from "@mui/icons-material";
import {useTranslation} from "react-i18next";
import {Grid, IconButton } from "@mui/material";
import {FormAutocomplete, FormTextField } from "../../../../../common/form-fields-wrappers";
import { INewColumn } from "./types";
import {useTheme} from "@mui/material";

const NewColumn = ({field, index, eParkingInfoForm, handleOnDelete, open}: INewColumn) => {
    const {t} = useTranslation(['network', 'translation']);
    const theme = useTheme();

    const typeList = ["Juice Pole", "Juice Box", "Juice Pump"];

    return (
        <>
            <Grid item xs={12} sm={6} md={3}>
                <FormTextField
                    control={eParkingInfoForm.control}
                    name={`chargingColumn.${index}.chargingColumnId`}
                    label={t("rsDetail.eParking.form.label.chargingColumnId")}
                    disabled={!open}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
                <FormAutocomplete
                    name={`chargingColumn.${index}.chargingColumnType`}
                    control={eParkingInfoForm.control}
                    options={typeList}
                    label={t("rsDetail.eParking.form.label.chargingColumnType")}
                    disabled={!open}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
                <FormTextField
                    disabled={!open}
                    control={eParkingInfoForm.control}
                    name={`chargingColumn.${index}.numberOfChargingPoint`}
                    label={t("rsDetail.eParking.form.label.numberOfChargingPoint")}
                />
            </Grid>
            {!!open &&
                <IconButton
                    sx={{mt: theme.spacing(2), ml: 'auto', mr: theme.spacing(2)}}
                    onClick={() => {handleOnDelete(index)}}
                >
                    <Delete/>
                </IconButton>
            }
        </>
    );
}

export default  NewColumn;